import {mapGetters} from 'vuex';
import mvtChart from '@/common/components/mvtchart/mvt-chart.vue';
var backgroundColor = [
    '#0561EB',
    '#00A5D6',
    '#6886B5',
    '#043683',
    '#021B42',
    '#757575',
    '#005B5E',
    '#1F8265',
    '#E2F3EC',
    '#FFF7E4',
    '#F6DCD6',
    '#E6EBF3'
]
export default {
    name: 'marketTrendsOverview',
    components:{
        mvtChart
    },
    props: {
        data: {
            type: Object,
            default: {}
        },
        paragraphics: {
            type: String,
            default: ''
        },
        isStatisticsGraph: {
            type: Boolean,
            default:false
        }
    },
    data(){
        return{
            chartData: null,
        }
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        getChartData() {
          return this.isStatisticsGraph ? this.getStatisticsChart() : this.getDemographicsChart()
        },
        getKeys() {
            return Object.keys(this.data.chartValues[0])
        }
    },
    methods: {

     getDemographicsChart() {
            const labels = this.data.chartValues.map(item => item.label)
            const data = this.data.chartValues.map(item => item.percentage)
            return {
                type: this.data.chartId == 5 ? 'bar' : 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                      data: data,
                      backgroundColor:  this.data.chartId == 5 ? backgroundColor[0] : backgroundColor.slice(0,this.data.chartValues.length),
                      borderWidth: 0
                    }]
                },
                options: {
                    cutoutPercentage: 50,
                    legend: {
                        display: this.data.chartId != 5 ,
                        position: 'bottom',
                        labels: {
                            usePointStyle: true,
                        }
                    },
                    responsive:true,
                    maintainAspectRatio: false,
                    aspectRatio:2,
                    scales: this.data.chartId == 5 ? {
                        xAxes: [{
                            gridLines: {
                            display: false
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                callback: function(value, index, values) {
                                    return value + '%';
                                }
                            }
                        }]
                    } : {},
                    tooltips: {
                        callbacks: {
                          label: function(tooltipItem, d) {
                            var label = d.labels[tooltipItem.index];
                            var value = ` :${d.datasets[0].data[tooltipItem.index]}% `
                            return label + value
                          }
                        }
                    }
                }
            };
    },


    getStatisticsChart() {
        return {
            type: 'bar',
            data: {
                labels: ['Last Year','Last Month','Today'],
                datasets: [{
                    label: 'House',
                    data: this.data.singleFamilyData,
                    backgroundColor:  backgroundColor[1],
                    borderWidth: 0
                },{
                    label: 'Condo/Townhome',
                    data: this.data.condoTownhomeData,
                    backgroundColor:  backgroundColor[3],
                    borderWidth: 0
                  }]
            },
            options: {
                cutoutPercentage: 50,
                legend: {
                    display: true ,
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                    }
                },
                responsive:true,
                maintainAspectRatio: false,
                aspectRatio:2,
                scales:{
                    xAxes: [{
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        ticks:{
                            beginAtZero: true,
                            callback: function(value, index, values) {
                                return `$${value ? value/100000 : 0}M`;
                            }
                        }
                    }]
                },
                tooltips: this.getStatisticsChartTooltip(),
            }
        }
    },

     getStatisticsChartTooltip() {
        let self = this;
        return {
            callbacks: {
              label: function(tooltipItem, data) {
                var label = data.datasets[tooltipItem.datasetIndex].label;
                var value = self.$options.filters.formatNumber(tooltipItem.value);
                return `${label} : $${value}`;
              }
            }
        }
     },

    }
};